import { Link } from 'react-router-dom';
import { ROUTES, insightsSectionUrl } from '@/constants';
import '@/styles/features/home/Footer.css';

interface FooterColumn {
  heading: string;
  links: { label: string; to: string }[];
}

const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: 'Solutions',
    links: [
      { label: 'Offerings', to: ROUTES.OFFERINGS },
      { label: 'Success Stories', to: ROUTES.SUCCESS_STORIES },
      { label: 'Accelerators', to: ROUTES.ACCELERATORS },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Events', to: ROUTES.EVENTS },
      { label: 'Insights', to: ROUTES.INSIGHTS },
      { label: 'Spec-Driven Development', to: insightsSectionUrl('sdd') },
      { label: 'About Us', to: ROUTES.ABOUT },
      // Why Winter tab disabled — keep for later re-enable.
      // { label: 'Why Winter', to: ROUTES.WHY_WINTER },
    ],
  },
  {
    heading: 'Resources',
    links: [{ label: 'Talk to an Architect', to: ROUTES.CONTACT }],
  },
];

const Footer = () => {
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <div className="foot-brand">
            <div className="foot-lockup">
              <img src="/assets/winter/winterMark.png" alt="winter" loading="lazy" />
              <span className="foot-divider" />
              <img className="foot-mdb-logo" src="/assets/winter/mdbLogo-new.svg" alt="MongoDB" loading="lazy" />
            </div>
            <p>
              Winter is an AI-native Operating Model for continuous enterprise modernization —
              combining our AI Platform &apos;The Protean&apos;, AI Agents, and the Winter Squad to deliver
              measurable value.
            </p>
            <div className="foot-social">
              <a href="https://www.linkedin.com/company/winterinc/home/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8.5h4.56V23H.22V8.5zM8.34 8.5h4.37v1.98h.06c.61-1.16 2.1-2.38 4.32-2.38 4.62 0 5.47 3.04 5.47 6.99V23h-4.56v-6.62c0-1.58-.03-3.62-2.2-3.62-2.21 0-2.55 1.73-2.55 3.51V23H8.34V8.5z" />
                </svg>
              </a>
            </div>
          </div>

          {FOOTER_COLUMNS.map((c) => (
            <div key={c.heading}>
              <h5>{c.heading}</h5>
              <ul>
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="foot-base">
          <span>© {new Date().getFullYear()} Winter Inc · winter.inc · All rights reserved.</span>
          <span className="foot-partner">
            <img src="/assets/winter/mdbLogo-new.svg" alt="MongoDB" loading="lazy" />
            Premier Partner
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
